module.exports = __webpack_public_path__ + "img/dialog_bg.d28ae159.png";